import React, { useEffect, useState } from 'react';
import { Alert, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { VoucherOut, VoucherService, VoucherStatus, VoucherType } from '../../api';
import { useAccountData } from '../StorefrontThemeWrapper';
import { customerFacingPriceFormatter } from '../../orderPage/utils';

export const StorefrontVoucherBalanceBanner = () => {
  const { t } = useTranslation();
  const account = useAccountData();
  const [searchParams] = useSearchParams();
  const voucherCode = searchParams.get('vouchercode');
  const [voucher, setVoucher] = useState<VoucherOut | undefined>(undefined);

  useEffect(() => {
    if (!voucherCode) {
      return;
    }
    VoucherService.getVoucher(voucherCode)
      .then(setVoucher)
      .catch(() => setVoucher(undefined));
  }, [voucherCode]);

  if (
    !account ||
    !voucher ||
    voucher.type !== VoucherType.MONETARY ||
    voucher.status !== VoucherStatus.ACTIVE ||
    !voucher.balance
  ) {
    return null;
  }

  return (
    <Grid item my={2}>
      <Alert severity="info">
        {t('storefront.giftCardBalanceBanner', { balance: customerFacingPriceFormatter(voucher.balance, account) })}
      </Alert>
    </Grid>
  );
};
